export enum memberActivationStatuses {
  act = '1',
  inactive = '2',
  frontEndInactive = '3'
}

export enum investorMyInfoEvents {
  PERSONAL_DETAILS = 'personal_details_submit_event',
  DOC_UPLOAD = 'document_upload_submit_event',
}

export enum investorManualEvents {
  PERSONAL_DETAILS = 'personal_details_submit_event',
  DOC_UPLOAD = 'document_upload_submit_event',
}

export enum memberCategoryCodes {
  CHANNELING_PARTNER = 'channeling_partner',
  CAPITAL = 'capital'
}

export enum verificationStatusMapping {
  NOT_EXIST = 'verification-not-exist',
  IN_PROGRESS = 'verification-in-progress',
  VERIFIED = 'verification-verified',
  REJECTED = 'verification-rejected',
  RETRYING = 'verification-retrying',
};
